// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentArea_yA1aG {
  padding: var(--size-padLarge) !important;
  display: flex;
  flex-direction: column;
  gap: var(--size-padMedium);
}

.content_Dcfqs {
  min-height: auto;
  max-height: 98vh;
  width: 496px;
}

.header_SF_IR {
  width: 100%;
  padding: var(--size-pad12) var(--size-padLarge);
}

.headerIcon_N_qah {
  width: 24px;
  height: 24px;
}

@media only screen and (max-width: 1023px) {
  .content_Dcfqs {
    height: 100vh;
    width: 100%;
  }

  .dialog_Up62h {
    border-radius: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/components/DefaultDialog.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".contentArea {\n  padding: var(--size-padLarge) !important;\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padMedium);\n}\n\n.content {\n  min-height: auto;\n  max-height: 98vh;\n  width: 496px;\n}\n\n.header {\n  width: 100%;\n  padding: var(--size-pad12) var(--size-padLarge);\n}\n\n.headerIcon {\n  width: 24px;\n  height: 24px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .content {\n    height: 100vh;\n    width: 100%;\n  }\n\n  .dialog {\n    border-radius: 0px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentArea": `contentArea_yA1aG`,
	"content": `content_Dcfqs`,
	"header": `header_SF_IR`,
	"headerIcon": `headerIcon_N_qah`,
	"dialog": `dialog_Up62h`
};
export default ___CSS_LOADER_EXPORT___;
